<template>
  <div class="container">
    <div>
      <h1>Cargue de Usuarios</h1>
    </div>
    <div class="btn-container">
      <div class="btn-title">
          <input
            type="file"
            class="btn-cargue"
            @change="handleFileChange"
            ref="fileInput"
            style="display: none;"
            accept=".xlsx, .xls"
          />
          <v-btn
            x-medium
            large
            block
            rounded
            color="#6E17A5"
            class="btn-cargue"
            dark
            @click="triggerFileInput"
          > Agregar Archivo
            <v-icon>mdi-paperclip</v-icon>
          </v-btn>
          <h2>{{titleFile}}</h2>
        </div>
      </div>
  </div>
</template>

<script>

  import {
    CARGUES_M,
    ACTION_CARGUE_EXCEL
  } from "@/views/cargues/store/types/types.js";
  import { mapActions } from "vuex";
  import Swal from 'sweetalert2';

  export default {
    name:"uploadFile",
    components: {
    },
    data () {
      return {
        dialog: false,
        titleFile: "Cargar un archivo",
      }
      
    },

    methods: {

      triggerFileInput() {
        this.$refs.fileInput.click();
      },

      async handleFileChange(event) {

        const fileInput = this.$refs.fileInput;
        const file = event.target.files[0];

        if (file && this.isValidExcelFile(file)) {
          this.titleFile = file.name
          const confirmResult = await Swal.fire({
            icon: "question",
            title: "Deseas iniciar el cargue?",
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
            confirmButtonColor: " #6E17A5",
            cancelButtonColor: " #6E17A5",
          });

          if (confirmResult.isConfirmed) {
            this.submitFile(file);
          } else {
            Swal.fire({
              icon: "info",
              title: "Cargue cancelado",
              showConfirmButton: false,
              timer: 1500,
              
            });

            fileInput.value = "";
             "Cargar un archivo";
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "El archivo no es del formato esperado (.xlsx, .xls).",
          });
          fileInput.value = "";
          this.titleFile = "Cargar un archivo";
        }
      },

      isValidExcelFile(file) {
        // Verificar si el nombre del archivo tiene una extensión permitida
        const allowedExtensions = [".xlsx", ".xls", ".csv"];
        const fileName = file.name.toLowerCase();
        return allowedExtensions.some(ext => fileName.endsWith(ext));
      },

      async submitFile(file) {
        await this.postFile(file)
      },

      ...mapActions({
        postFile: `${CARGUES_M}${ACTION_CARGUE_EXCEL}`,
      }),
    },

    computed: { 
      // ...mapGetters({
      // }),
    }
  };

</script>
  
<style lang="css" scoped>

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
  }
  
  .btn-container {
    margin-top: 20px; /* Ajusta según tu diseño */
  }
  
  .btn-cargue {
    color: white;
    border-radius: 23px;
    width: 25vh;
    align-items:center
  }

  .btn-title{
    display: flex;
    flex-direction: column;
    gap: 1vh;
    align-items: center;
  }

  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
      font-family: "Nunito Sans", sans-serif;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Amsi Pro", sans-serif;
      color: #2d0049;
      font-weight: normal;
    }  
    h1{
      font-size: 4vh;
    }
    /* responsive */

    @media screen and (max-width: 1024px) {
        .btn-cargue {
            width: 30vh;
        }
    }

    @media screen and (max-width: 414px) {
        .btn-cargue {
            width: 32vh;
            margin-left: 2vh
        }
        h1{
            font-size:3vh;
            margin-left:2vh
        }
    }

    @media screen and (min-width: 414px) {
        .btn-cargue {
            width: 32vh;
            margin-left: 2vh
        }
        h1{
            margin-left:2vh
        }
    }
 
    @media screen and (max-width: 280px) { 

        .btn-cargue {
            width: 25vh;
            font-size:10px;
            margin-left:2vh
        }
        h1{
            font-size:3vh;
            margin-left:2vh
        }
        h2{
            font-size:2vh;
        }
    } 

</style>
  